<ng-container matColumnDef="phone_input">
  <form #f="ngForm" [formGroup]="phoneForm" [attr.autocomplete]="disableBrowserAutofill ? 'off' : null" [attr.data-lpignore]="disableBrowserAutofill ? 'true' : null" [attr.data-form-type]="disableBrowserAutofill ? 'other' : null">
    <div class="wrapper phone-field mb-4">
      <div
        class="mat-like-field mat-like-outline always-float-label full-width mb-0"
        [class.has-value]="!empty"
        [class.disabled]="phoneForm.get('phone')?.disabled"
        [class.invalid]="showPhoneError"
        (focusin)="onPhoneFocus()">
        @if (labelInput) {
          <label class="mat-like-label">
            {{ required ? labelInput + '*' : labelInput }}
          </label>
        }
        <ngx-intl-tel-input
          [cssClass]="inputClass"
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="selectedCountry"
          [maxLength]="mobileMaxLength"
          [phoneValidation]="true"
          [separateDialCode]="separateDialCode"
          [inputId]="idInput"
          (countryChange)="onChange($event)"
          #phoneInput
          name="phone"
          formControlName="phone">
        </ngx-intl-tel-input>
      </div>
      <div class="px-3">

        @if (hintInput && !showPhoneError) {
          <div class="mat-like-hint">
            {{ hintInput }}
          </div>
        }

        @if (showPhoneError) {
          <div class="mat-like-error">
            Please enter a valid phone number.
          </div>
        }

      </div>
    </div>
  </form>
</ng-container>
